var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"holder"},[_c('img',{attrs:{"src":require("../assets/imgs/logo-petit-nature.jpg"),"alt":""}}),_c('login-form')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }